// import { AuthContext } from 'contexts/AuthContext';
// import { useContext, useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const SelectClass = ({ classData, setClassData, courses, loadingCourses }) => {
//   const [errors, setErrors] = useState([]);
//   const { state } = useContext(AuthContext);

//   const [batches, setBatches] = useState([]);
//   const navigate = useNavigate();

//   const handleCourseChange = (event) => {
//     const courseId = event.target.value;
//     const selectedCourse = courses.find(
//       (course) => course.courseId === courseId
//     );
//     setBatches(selectedCourse?.batches || []);
//     setClassData({ ...classData, courseId, batchId: '' });
//   };

//   const handleBatchChange = (event) => {
//     const batchId = event.target.value;
//     setClassData({ ...classData, batchId });
//   };

//   useEffect(() => {
//     if (classData.courseId) {
//       const selectedCourse = courses.find(
//         (course) => course.courseId === classData.courseId
//       );
//       setBatches(selectedCourse?.batches || []);
//     }
//   }, [classData.courseId, courses]);

//   return (
//     <div className="w-full rounded-lg ">
//       {/* Header */}
//       <div className="flex justify-center">
//         <h4 className="text-lg font-bold text-navy-700 dark:text-white">
//           Select Class Information
//         </h4>
//       </div>

//       {/* Course Select */}
//       <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
//         <div className="w-full md:w-1/2">
//           <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
//             Select Course
//           </label>
//           <select
//             onChange={handleCourseChange}
//             value={classData?.courseId}
//             name="course"
//             className="cursor-pointer mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
//           >
//             <option value="">Click here to Select Course</option>
//             {loadingCourses ? (
//               <option>Loading courses...</option>
//             ) : (
//               <>
//                 {' '}
//                 {courses.map((course, i) => (
//                   <option key={course.courseId} value={course.courseId}>
//                     {i + 1}. {course.courseName}
//                   </option>
//                 ))}
//               </>
//             )}
//           </select>
//         </div>

//         {/* Batch Select */}
//         <div className="w-full md:w-1/2">
//           <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
//             Select Batch
//           </label>
//           <select
//             onChange={handleBatchChange}
//             value={classData?.batchId}
//             name="batch"
//             className="cursor-pointer mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
//           >
//             <option value="">Click here to Select Batch</option>
//               {batches.length > 0 ? (
//   batches.map((batch) => {
//     // Extract unique times from daySchedules
//     const times = batch.daySchedules?.map(ds => ds.startTime).filter(Boolean);
//     const uniqueTimes = [...new Set(times)]; // remove duplicates
//     const timeDisplay = uniqueTimes.length > 0 ? ` at ${uniqueTimes.join(' / ')}` : '';

//     return (
//       <option key={batch._id} value={batch._id}>
//         B {batch.batchNumber} - From {new Date(batch.startDate).toLocaleDateString()} {""}
//         to {new Date(batch.endDate).toLocaleDateString()}
//         {timeDisplay}
//       </option>
//     );
//   })
// )  : (
//               <option className="cursor-pointer" value="">
//                 No batches available
//               </option>
//             )}
//           </select>
//         </div>
//       </div>
//       {/* Display errors */}
//       {errors.length > 0 && (
//         <div className="text-red-500">
//           {errors.map((error, index) => (
//             <p key={index}>{error}</p>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SelectClass;
import { useEffect, useState } from 'react';

const SelectClass = ({
  classData,
  setClassData,
  courses,
  batchStructures = [],
  fetchBatchStructures,
  fetchBatchesByStructure,
  loadingCourses,
  setDisable,
  clearAttendance,
  loading,
  presetBatches,
}) => {
  const [batches, setBatches] = useState([]);

  /* ================= COURSE CHANGE ================= */
  const handleCourseChange = async (e) => {
    const courseId = e.target.value;

    setClassData({
      courseId,
      batchStructureId: '',
      batchId: '',
    });

    setBatches([]);
    clearAttendance?.();
    setDisable?.(true);

    if (courseId) {
      await fetchBatchStructures(courseId);
    }
  };

  /* ================= BATCH STRUCTURE CHANGE ================= */
  const handleBatchStructureChange = async (e) => {
    const batchStructureId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      batchStructureId,
      batchId: '',
    }));

    setBatches([]);
    setDisable?.(true);

    if (batchStructureId) {
      const fetchedBatches = await fetchBatchesByStructure(batchStructureId);
      setBatches(fetchedBatches || []);
    }
  };

  /* ================= BATCH CHANGE ================= */
  const handleBatchChange = (e) => {
    const batchId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      batchId,
    }));

    if (batchId) {
      setDisable?.(false);
    }
  };

  /* ================= RESET ON COURSE CLEAR ================= */
  useEffect(() => {
    if (presetBatches?.length > 0) {
      setBatches(presetBatches);
    }
  }, [presetBatches]);

  useEffect(() => {
    if (!classData.courseId) {
      setBatches([]);
      setDisable?.(true);
    }
  }, [classData.courseId, setDisable]);

  return (
    <div className="w-full rounded-lg">
      {/* ================= HEADER ================= */}
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      {/* ================= SELECTS ================= */}
      <div className="mt-6 flex flex-col gap-6 md:flex-row md:justify-center">
        {/* ================= COURSE ================= */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            value={classData.courseId}
            onChange={handleCourseChange}
            disabled={loading}
            className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none disabled:opacity-60 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : (
              courses.map((course, i) => (
                <option key={course._id} value={course._id}>
                  {i + 1}. {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>

        {/* ================= BATCH STRUCTURE ================= */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch Structure
          </label>
          <select
            value={classData.batchStructureId}
            onChange={handleBatchStructureChange}
            disabled={!classData.courseId || loading}
            className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none disabled:opacity-60 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Batch Structure</option>
            {batchStructures.map((structure, i) => (
              <option key={structure._id} value={structure._id}>
                {i + 1}. {structure.structureName || structure.name}
              </option>
            ))}
          </select>
        </div>

        {/* ================= BATCH ================= */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch
          </label>
          <select
            value={classData.batchId}
            onChange={handleBatchChange}
            disabled={!classData.batchStructureId || loading}
            className="mt-2 w-full md:min-w-[400px] cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none disabled:opacity-60 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Batch</option>

            {batches.length > 0 ? (
              batches.map((b) => {
                const batchDisplay = `B${b.batchNumber}`;
                
                const date = new Date(b.startDate);
                const day = date.getDate().toString().padStart(2, '0');
                const month = date.toLocaleString('default', { month: 'short' });
                const year = date.getFullYear().toString().slice(-2);
                const dateDisplay = `${day}${month}${year}`;

                const dayMap = {
                  Monday: 'M',
                  Tuesday: 'T',
                  Wednesday: 'W',
                  Thursday: 'Th',
                  Friday: 'F',
                  Saturday: 'S',
                  Sunday: 'Su',
                };

                const scheduleDisplay = b.daySchedules
                  ?.map((schedule) => {
                    const dayShort = dayMap[schedule.day] || schedule.day;
                    const time = schedule.startTime.replace(':00', '').replace(' ', '');
                    return `${dayShort}-${time}`;
                  })
                  .join(' | ');

                const branchInitials = b.branches
                  ?.map((br) => br.name.split(',').pop().trim()[0])
                  .join('');

                const schedulePart = scheduleDisplay ? `(${scheduleDisplay} )` : '';
                const fullDisplay = `${batchDisplay} | ${dateDisplay} ${schedulePart} ${branchInitials || ''}`.trim();

                return (
                  <option key={b._id} value={b._id}>
                    {fullDisplay}
                  </option>
                );
              })
            ) : (
              <option value="">No batches available</option>
            )}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SelectClass;
